/**
 * Route for `anura-integration`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { AnuraIntegrationPage } from "../features/anura-integration/AnuraIntegrationPage";

export const anuraIntegrationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/anura-integration",
	component: AnuraIntegrationPage,
});

export default anuraIntegrationRoute;
